module.exports = __webpack_public_path__ + "static/img/IMG_20170720_130244.86426ceb.jpg";